import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';
import { useProfile } from '../Contexts/UserProfileContext';
import styled from 'styled-components';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import DavieLogoWhite from '../Assets/davieai-logo-white.png';
import { NestedMenuItem } from 'mui-nested-menu';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useAdvertisers } from '../Contexts/AdvertisersContext';
// https://mui-nested-menu.vercel.app/nested-menu-item

const StyledNavbar = styled.div`
    .MuiAppBar-colorPrimary {
        background: #2e69fe 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 3px #00000061;
        opacity: 1;
    }
`;

const DavieLogo = styled.img`
    width: 160px;
    margin-right: 20px;
    object-fit: contain;
`;

const MenuContainer = styled.div``;

const StyledMenuItem = styled.span`
    font-weight: 400;
    color: #fafbf7;
    font-family: 'Montserrat', sans-serif;
    text-transform: none;
    font-size: 15px;
`;

const useStyles = makeStyles({
    menu: {
        '& .MuiPaper-root': {
            backgroundColor: '#ff8560',
            color: 'white',
            marginTop: '0px',
            marginBottom: '0px',
        },

        '& .MuiMenuItem-root': {
            minHeight: '50px',
        },

        '& .MuiMenuItem-root:hover': {
            backgroundColor: 'white',
            color: 'black',
        },
        '& .MuiMenu-list': {
            paddingTop: '0px',
            paddingBottom: '0px',
        },
    },
});

const StyledTextField = styled(TextField)`
    width: 100%;

    .MuiOutlinedInput-root {
        background-color: #fafbf7;
    }
`;

const TeachNotification = styled.div`
    width: 100%;
    background-color: #ff8560;
    text-align: center;
    color: white;
`;
function Navbar() {
    const classes = useStyles();
    const { advertisers, setAdvertisers, setCurrentAdvertiser, currentAdvertiser, advertiserMetaData } = useAdvertisers();
    const history = useHistory();
    const { profile } = useProfile();
    const { logout, currentUser } = useAuth();

    const { advertiserList } = { ...advertisers };

    const advertiserListIsLoading = advertiserList?.length < 1 || advertiserList === undefined;
    const { hasCompletedData } = { ...advertiserMetaData?.selectedAdvertiserTeachData };

    const profileIsLoading = profile.userId === '';

    const role = {
        isAgency: profile.isAgency,
        isAdvertiser: profile.isIndividual,
        isSiteAdmin: profile.isSiteAdmin,
        isAgencyManager: profile.canIManageAgency,
        canIUseAgencyAdvertisers: profile.canIUseAgencyAdvertisers,
    };

    const [menuIcon, setMenuIcon] = useState(null);
    const menuIconIsOpen = Boolean(menuIcon);

    const onMenuIconClick = (e) => setMenuIcon(e.currentTarget);
    const onMenuIconClose = () => setMenuIcon(null);

    const [agencyItem, setAgencyItem] = useState(null);
    const agencyItemIsOpen = Boolean(agencyItem);

    const onAgencyItemClick = (e) => setAgencyItem(e.currentTarget);
    const onAgencyItemClose = () => setAgencyItem(null);

    const [advertiserItem, setAdvertiserItem] = useState(null);
    const advertiserItemIsOpen = Boolean(advertiserItem);

    const onAdvertiserItemClick = (e) => setAdvertiserItem(e.currentTarget);
    const onAdvertiserItemClose = () => setAdvertiserItem(null);

    const [campaignsItem, setCampaignsItem] = useState(null);
    const campaignsItemIsOpen = Boolean(campaignsItem);

    const onCampaignsItemClick = (e) => setCampaignsItem(e.currentTarget);
    const onCampaignsItemClose = () => setCampaignsItem(null);

    const [creativesItem, setCreativesItem] = useState(null);
    const creativesItemIsOpen = Boolean(creativesItem);

    const onCreativesItemClick = (e) => setCreativesItem(e.currentTarget);
    const onCreativesItemClose = () => setCreativesItem(null);

    const [leadGenItem, setLeadGenItem] = useState(null);
    const leadGenItemIsOpen = Boolean(leadGenItem);

    const onLeadGenItemClick = (e) => setLeadGenItem(e.currentTarget);
    const onLeadGenItemClose = () => setLeadGenItem(null);

    const [analyticsItem, setAnalyticsItem] = useState(null);
    const analyticsItemIsOpen = Boolean(analyticsItem);

    const onAnalyticsItemClick = (e) => setAnalyticsItem(e.currentTarget);
    const onAnalyticsItemClose = () => setAnalyticsItem(null);

    const [adServicesItem, setAdServicesItem] = useState(null);
    const adServicesItemIsOpen = Boolean(adServicesItem);

    const onAdServicesItemClick = (e) => setAdServicesItem(e.currentTarget);
    const onAdServicesItemClose = () => setAdServicesItem(null);

    const handleGoToRoute = (route, closeFunc) => {
        history.push(route);
        closeFunc();
    };

    const menuItems = {
        agency: [
            {
                label: 'Agency Information',
                onClick: () => handleGoToRoute('/portal/agency/agencyInformation', onAgencyItemClose),
            },
            {
                label: 'Add/View Advertisers',
                onClick: () => handleGoToRoute('/portal/agency/viewAdvertisers', onAgencyItemClose),
            },
        ],
        advertiser: [
            {
                label: 'Advertiser Information',
                onClick: () => handleGoToRoute('/portal/advertiser/advertiserInformation', onAdvertiserItemClose),
            },
            {
                label: 'Update Payment Method',
                onClick: () => handleGoToRoute('/portal/advertiser/updatePaymentMethod', onAdvertiserItemClose),
            },
        ],
        campaigns: [
            {
                label: 'Create a Campaign',
                onClick: () => handleGoToRoute('/portal/campaign/createACampaign', onCampaignsItemClose),
            },
            {
                label: 'View Campaigns',
                onClick: () => handleGoToRoute('/portal/campaign/viewCampaigns', onCampaignsItemClose),
            },
        ],
        creatives: [
            {
                label: 'Ad Builder',
                onClick: () => handleGoToRoute('/portal/adBuilder/buildAnAd', onCreativesItemClose),
            },
            // {
            //     label: 'Video Builder',
            //     onClick: () =>
            //         handleGoToRoute('/portal/adBuilder/videoBuilder', onCreativesItemClose),
            // },
        ],
        leadGen: [
            {
                label: 'Build a Landing Page',
                onClick: () => handleGoToRoute('/portal/leads/leadGeneration', onLeadGenItemClose),
            },
        ],
        analytics: [
            {
                label: 'View Analytics',
                onClick: () => handleGoToRoute('/portal/analytics/viewGlobalAnalytics', onAnalyticsItemClose),
            },
        ],
        adServices: [
            {
                label: 'View Ad Services',
                onClick: () => handleGoToRoute('/portal/adServices/viewAdServices', onAdServicesItemClose),
            },
        ],
        profile: [
            {
                label: 'Settings',
                onClick: () => handleGoToRoute('/portal/settings', onMenuIconClose),
            },
            {
                label: 'Log Out',
                onClick: () => logout(),
            },
        ],
    };

    const menuId = 'primary-search-account-menu';

    const [anchorEl, setAnchorEl] = React.useState(null);
    const isMenuOpen = Boolean(anchorEl);

    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLogoutBtn = () => {
        logout();
        handleMenuClose();
    };

    const renderMenu = (
        <Menu
            className={classes.menu}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={() => handleGoToRoute('/portal/settings', handleMenuClose)}>Settings</MenuItem>
            <MenuItem onClick={() => handleLogoutBtn()}>Log Out</MenuItem>
        </Menu>
    );

    const accountIsComplete = currentUser?.isAuthenticated && currentUser?.emailIsVerified && currentUser?.accountIsComplete;

    const handleAdvertiserChange = (e, value) => {
        setCurrentAdvertiser(value);
    };
    return (
        <div>
            <StyledNavbar id="navbar">
                <AppBar position="static">
                    <Container maxWidth="xl">
                        <Toolbar disableGutters>
                            <Typography
                                variant="h6"
                                noWrap
                                component="a"
                                href="/portal/dashboard"
                                sx={{
                                    mr: 2,
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: 'monospace',
                                    fontWeight: 700,
                                    letterSpacing: '.3rem',
                                    color: 'inherit',
                                    textDecoration: 'none',
                                }}
                            >
                                <DavieLogo src={DavieLogoWhite} />
                            </Typography>
                            {accountIsComplete ? (
                                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={onMenuIconClick}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    <Menu className={classes.menu} anchorEl={menuIcon} open={menuIconIsOpen} onClose={onMenuIconClose}>
                                        {role.isAgency ? (
                                            <NestedMenuItem label="Agency" parentMenuOpen={menuIconIsOpen}>
                                                <MenuItem onClick={() => history.push('/portal/agency/agencyInformation')}>
                                                    Agency Information
                                                </MenuItem>
                                                <MenuItem onClick={() => history.push('/portal/agency/viewAdvertisers')}>
                                                    Add/View Advertisers
                                                </MenuItem>
                                            </NestedMenuItem>
                                        ) : null}
                                        {role.isAgency || role.isAdvertiser ? (
                                            <NestedMenuItem label="Advertiser" parentMenuOpen={menuIcon}>
                                                <MenuItem onClick={() => history.push('/portal/advertiser/advertiserInformation')}>
                                                    Advertiser Information
                                                </MenuItem>
                                                <MenuItem onClick={() => history.push('/portal/advertiser/updatePaymentMethod')}>
                                                    Update Payment Method
                                                </MenuItem>
                                            </NestedMenuItem>
                                        ) : null}

                                        <NestedMenuItem label="Campaigns" parentMenuOpen={menuIcon}>
                                            <MenuItem onClick={() => history.push('/portal/campaign/createACampaign')}>Create a Campaign</MenuItem>
                                            <MenuItem onClick={() => history.push('/portal/campaign/viewCampaigns')}>View Campaigns</MenuItem>
                                        </NestedMenuItem>
                                        <NestedMenuItem label="Creatives" parentMenuOpen={menuIcon}>
                                            <MenuItem onClick={() => history.push('/portal/adBuilder/buildAnAd')}>Ad Builder</MenuItem>
                                            <MenuItem onClick={() => history.push('/portal/adBuilder/videoBuilder')}>Video Builder</MenuItem>
                                        </NestedMenuItem>
                                        <NestedMenuItem label="Lead Gen" parentMenuOpen={menuIcon}>
                                            <MenuItem onClick={() => history.push('/portal/leads/leadGeneration')}>Build a Landing Page</MenuItem>
                                        </NestedMenuItem>
                                        <NestedMenuItem label="Analytics" parentMenuOpen={menuIcon}>
                                            <MenuItem onClick={() => history.push('/portal/analytics/viewGlobalAnalytics')}>View Analytics</MenuItem>
                                        </NestedMenuItem>
                                        <NestedMenuItem label="Ad Services" parentMenuOpen={menuIcon}>
                                            <MenuItem onClick={() => history.push('/portal/adServices/viewAdServices')}>Ad Services</MenuItem>
                                        </NestedMenuItem>
                                    </Menu>
                                </Box>
                            ) : null}
                            <Typography
                                variant="h5"
                                noWrap
                                component="a"
                                href="/portal/dashboard"
                                sx={{
                                    mr: 2,
                                    display: { xs: 'flex', md: 'none' },
                                    flexGrow: 1,
                                    fontFamily: 'monospace',
                                    fontWeight: 700,
                                    letterSpacing: '.3rem',
                                    color: 'inherit',
                                    textDecoration: 'none',
                                }}
                            >
                                <DavieLogo src={DavieLogoWhite} />
                            </Typography>
                            {accountIsComplete ? (
                                <>
                                    {profileIsLoading ? (
                                        <Skeleton animation="wave" width="600px" />
                                    ) : (
                                        <>
                                            {' '}
                                            <Box
                                                sx={{
                                                    flexGrow: 1,
                                                    display: { xs: 'none', md: 'flex' },
                                                }}
                                            >
                                                <Button
                                                    onClick={() => history.push('/portal/dashboard')}
                                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                                >
                                                    <StyledMenuItem>Dashboard</StyledMenuItem>
                                                </Button>
                                                {role.isAgency ? (
                                                    <>
                                                        <Button
                                                            onClick={onAgencyItemClick}
                                                            sx={{
                                                                my: 2,
                                                                color: 'white',
                                                                display: 'block',
                                                            }}
                                                        >
                                                            <StyledMenuItem>Agency</StyledMenuItem>
                                                        </Button>
                                                        <MenuContainer>
                                                            <Menu
                                                                className={classes.menu}
                                                                anchorEl={agencyItem}
                                                                open={agencyItemIsOpen}
                                                                onClose={onAgencyItemClose}
                                                            >
                                                                {menuItems.agency.map((item) => (
                                                                    <div key={item.label}>
                                                                        <MenuItem onClick={item.onClick}>{item.label}</MenuItem>
                                                                    </div>
                                                                ))}
                                                            </Menu>
                                                        </MenuContainer>
                                                    </>
                                                ) : null}
                                                {role.isAgency || role.isAdvertiser ? (
                                                    <>
                                                        <Button
                                                            sx={{
                                                                my: 2,
                                                                color: 'white',
                                                                display: 'block',
                                                            }}
                                                            onClick={onAdvertiserItemClick}
                                                        >
                                                            <StyledMenuItem>Advertiser</StyledMenuItem>
                                                        </Button>
                                                        <Menu
                                                            className={classes.menu}
                                                            anchorEl={advertiserItem}
                                                            open={advertiserItemIsOpen}
                                                            onClose={onAdvertiserItemClose}
                                                        >
                                                            {menuItems.advertiser.map((item) => [
                                                                <MenuItem key={item.label} onClick={item.onClick}>
                                                                    {item.label}
                                                                </MenuItem>,
                                                            ])}
                                                        </Menu>
                                                    </>
                                                ) : null}

                                                <Button onClick={onCampaignsItemClick} sx={{ my: 2, color: 'white', display: 'block' }}>
                                                    <StyledMenuItem>Campaigns</StyledMenuItem>
                                                </Button>
                                                <Menu
                                                    className={classes.menu}
                                                    anchorEl={campaignsItem}
                                                    open={campaignsItemIsOpen}
                                                    onClose={onCampaignsItemClose}
                                                >
                                                    {menuItems.campaigns.map((item) => [
                                                        <MenuItem key={item.label} onClick={item.onClick}>
                                                            {item.label}
                                                        </MenuItem>,
                                                    ])}
                                                </Menu>

                                                <Button onClick={onCreativesItemClick} sx={{ my: 2, color: 'white', display: 'block' }}>
                                                    <StyledMenuItem>Creatives</StyledMenuItem>
                                                </Button>
                                                <Menu
                                                    className={classes.menu}
                                                    anchorEl={creativesItem}
                                                    open={creativesItemIsOpen}
                                                    onClose={onCreativesItemClose}
                                                >
                                                    {menuItems.creatives.map((item) => [
                                                        <MenuItem key={item.label} onClick={item.onClick}>
                                                            {item.label}
                                                        </MenuItem>,
                                                    ])}
                                                </Menu>
                                                <Button onClick={onLeadGenItemClick} sx={{ my: 2, color: 'white', display: 'block' }}>
                                                    <StyledMenuItem>Lead Gen</StyledMenuItem>
                                                </Button>
                                                <Menu
                                                    className={classes.menu}
                                                    anchorEl={leadGenItem}
                                                    open={leadGenItemIsOpen}
                                                    onClose={onLeadGenItemClose}
                                                >
                                                    {menuItems.leadGen.map((item) => [
                                                        <MenuItem key={item.label} onClick={item.onClick}>
                                                            {item.label}
                                                        </MenuItem>,
                                                    ])}
                                                </Menu>
                                                {/* <Button
                                                    onClick={onAnalyticsItemClick}
                                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                                >
                                                    <StyledMenuItem>Analytics</StyledMenuItem>
                                                </Button> */}
                                                <Menu
                                                    className={classes.menu}
                                                    anchorEl={analyticsItem}
                                                    open={analyticsItemIsOpen}
                                                    onClose={onAnalyticsItemClose}
                                                >
                                                    {menuItems.analytics.map((item) => [
                                                        <MenuItem key={item.label} onClick={item.onClick}>
                                                            {item.label}
                                                        </MenuItem>,
                                                    ])}
                                                </Menu>
                                                <Button onClick={onAdServicesItemClick} sx={{ my: 2, color: 'white', display: 'block' }}>
                                                    <StyledMenuItem>Ad Services</StyledMenuItem>
                                                </Button>
                                                <Menu
                                                    className={classes.menu}
                                                    anchorEl={adServicesItem}
                                                    open={adServicesItemIsOpen}
                                                    onClose={onAdServicesItemClose}
                                                >
                                                    {menuItems.adServices.map((item) => [
                                                        <MenuItem key={item.label} onClick={item.onClick}>
                                                            {item.label}
                                                        </MenuItem>,
                                                    ])}
                                                </Menu>

                                                {/* <Button
                                                    onClick={() =>
                                                        window.open(
                                                            'https://davieexperts.com/',
                                                            '_blank',
                                                            'noopener noreferrer'
                                                        )
                                                    }
                                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                                >
                                                    <StyledMenuItem>Ask An Expert</StyledMenuItem>
                                                </Button> */}
                                            </Box>
                                            <Box>
                                                <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                                                    {role.isAgency ? (
                                                        <div
                                                            style={{
                                                                marginTop: '10px',
                                                                marginRight: '10px',
                                                                display: 'flex',
                                                            }}
                                                        >
                                                            {advertiserListIsLoading ? (
                                                                <Skeleton animation="wave" width="200px" />
                                                            ) : (
                                                                <>
                                                                    <div
                                                                        style={{
                                                                            marginTop: '10px',
                                                                            marginRight: '10px',
                                                                            display: 'flex',
                                                                        }}
                                                                    >
                                                                        Current Advertiser:
                                                                    </div>
                                                                    <Autocomplete
                                                                        size="small"
                                                                        disablePortal
                                                                        id="combo-box-demo"
                                                                        options={advertiserList || []}
                                                                        value={currentAdvertiser}
                                                                        getOptionLabel={(option) => `${option.companyName}`}
                                                                        onChange={(e, value) => handleAdvertiserChange(e, value)}
                                                                        sx={{ width: 300 }}
                                                                        renderInput={(params) => (
                                                                            <StyledTextField {...params} placeholder="Select Advertiser" />
                                                                        )}
                                                                    />
                                                                </>
                                                            )}
                                                        </div>
                                                    ) : null}
                                                    <IconButton
                                                        size="large"
                                                        edge="end"
                                                        aria-label="account of current user"
                                                        aria-controls={menuId}
                                                        aria-haspopup="true"
                                                        onClick={handleProfileMenuOpen}
                                                        color="inherit"
                                                    >
                                                        <Avatar alt={profile.firstName} src="/static/images/avatar/2.jpg" />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        </>
                                    )}
                                </>
                            ) : null}
                        </Toolbar>
                    </Container>
                </AppBar>
                {renderMenu}
            </StyledNavbar>
            {currentUser.isAuthenticated && role.isAgency === true && hasCompletedData === false ? (
                <TeachNotification>The advertiser you have selected has not trained davie.ai yet.</TeachNotification>
            ) : null}
        </div>
    );
}

export default Navbar;
